import React from 'react'

export default function RegExp() {
  return (
    
    <div>RegExp</div>
  )
}
